import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMobileScreen } from '@fortawesome/pro-solid-svg-icons';

import Association from './association';
import CopyOverlay from 'components/copy_overlay';
import { formatPhoneNumber } from 'helpers/formatters/phone_number_formats';

import type { Contact } from 'bundles/crm/associations/types';

interface Props {
  contact: Contact;
  showEmployer?: boolean;
}

export default function ContactAssociation({ contact, showEmployer = true, ...props }: Props) {
  const subheaderParts = [contact.role];
  if (showEmployer && contact.business) {
    subheaderParts.push(contact.business);
  }

  return (
    <Association
      {...props}
      header={contact.name}
      path={contact.path}
      subheader={subheaderParts.join(' · ')}
    >
      <div className="d-flex flex-row align-items-center justify-content-between w-100">
        {contact.phone && (
          <CopyOverlay
            className="d-flex align-items-center overflow-hidden crm-page__associations__panel__attribute"
            dark
            text={contact.phone}
          >
            <FontAwesomeIcon className="mr-2" icon={faMobileScreen} size="sm"/>
            <a className="text-truncate"><small>{formatPhoneNumber(contact.phone)}</small></a>
          </CopyOverlay>
        )}
        {contact.email && (
          <CopyOverlay
            className="d-flex align-items-center overflow-hidden crm-page__associations__panel__attribute"
            dark
            text={contact.email}
          >
            <FontAwesomeIcon className="mr-2" icon={faEnvelope} size="sm"/>
            <a className="text-truncate"><small>{contact.email}</small></a>
          </CopyOverlay>
        )}
      </div>
    </Association>
  );
}
